import React from 'react';
import FormTitle from "../../components/FormTitle/FormTitle";
import Stepper from '../../components/Stepper/Stepper';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import DetailsBanner from '../../components/Banner/DetailsBanner';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import useMainContainer from './useMainContainer';
import FormShimmer from '../../components/Shimmer/FormShimmer';
import Shimmer from '../../components/Shimmer/Shimmer';

function Main() {

  const { isMounted } = useMainContainer();

  return (
    <>
      <Container maxWidth="xxl" sx={{ mb: 6 }} >
        <Paper elevation={5} sx={{ my: { xs: 2, md: 3 }, p: { xs: 2, md: 3 } }}>
        <Grid container >
          <Grid
            md={12}
            sm={12}
            sx={{
              pl: {md: 2 },
              pt: 4
            }}>
            <FormTitle />
            {isMounted ? 
              <Stepper /> : <Shimmer />
            }
          </Grid>
        </Grid>
        </Paper>
      </Container>
    </>
  );
}

export default Main;
